var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBox({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.58554 4.65659L8.49983 8.11374M8.49983 8.11374L15.4141 4.65659M8.49983 8.11374L8.49983 16.5137M4.9284 2.75659L12.0713 6.32802M9.13554 1.29231L14.8498 4.14945C15.0878 4.26772 15.2881 4.45004 15.4282 4.67591C15.5683 4.90178 15.6425 5.16225 15.6427 5.42802V12.2352C15.6425 12.5009 15.5683 12.7614 15.4282 12.9873C15.2881 13.2131 15.0878 13.3955 14.8498 13.5137L9.13554 16.3709C8.93707 16.4702 8.71819 16.5219 8.49625 16.5219C8.27432 16.5219 8.05544 16.4702 7.85697 16.3709L2.14268 13.5137C1.90492 13.3939 1.70536 13.2101 1.56653 12.9829C1.4277 12.7557 1.35512 12.4943 1.35697 12.228V5.42802C1.35711 5.16225 1.43139 4.90178 1.57145 4.67591C1.71152 4.45004 1.91182 4.26772 2.14983 4.14945L7.86411 1.29231C8.06165 1.19415 8.27924 1.14307 8.49983 1.14307C8.72041 1.14307 8.938 1.19415 9.13554 1.29231Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/Box.cc0a582dcaba8a16e2ec81b045c7510d.svg";
export { ForwardRef as ReactComponent };